import styled, { css } from 'styled-components';

import ContentMedia from 'components/ContentMedia/ContentMedia';
import Headline from 'components/Headline/Headline';
import InfiniteSlider from 'components/InfiniteSlider/InfiniteSlider';
import OvalCTA from 'components/OvalCTA/OvalCTA';
import VideoBlockComponent from 'components/VideoBlock/VideoBlock';
import { mediaTablet } from 'utils/styles/responsive';

export const HeroWrapper = styled.section`
  height: 100%;
  position: relative;

  margin-bottom: 46px;

  ${mediaTablet`
      margin-bottom: 92px;
  `}
`;

const FullscreenMedia = css`
  width: 100%;
  height: 100%;
  inset: 0;
`;

export const FullScreenWrapper = styled.div`
  position: fixed;
  ${FullscreenMedia}
`;

export const OverlayButton = styled.div<{ isFullScreen?: boolean }>`
  position: absolute !important;
  ${FullscreenMedia}

  display: grid;
  height: ${({ isFullScreen }) => (isFullScreen ? '90%' : 'auto')};
  aspect-ratio: 16/9;
  inset: 0;
  cursor: pointer;

  @media screen and (orientation: landscape) {
    height: ${({ isFullScreen }) => (isFullScreen ? '80%' : 'auto')};
  }
`;

export const FullScreenVideoBlock = styled(VideoBlockComponent)`
  position: fixed;
  ${FullscreenMedia}
`;

export const ContentMediaBlock = styled(ContentMedia)`
  position: fixed;
  ${FullscreenMedia}
`;

export const HeadingSlider = styled(InfiniteSlider)`
  width: 100vw;
`;

export const BottomHeading = styled(Headline)`
  white-space: nowrap;
  padding: 20px;
`;

export const VideoBlock = styled(VideoBlockComponent)`
  pointer-events: none;
`;

export const BackgroundVideo = styled.video`
  width: 0;
  height: 0;
`;

export const PlayButton = styled(OvalCTA)`
  position: absolute;
  inset: 0;
  margin: auto;
`;

export const PlayButtonWrapper = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
`;
